export { default as SuccessInfoBox } from "./successInfoBox";
